import { SelectionModel } from '@angular/cdk/collections';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { FlatTreeControl } from '@angular/cdk/tree';
import { Component, Injectable, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, catchError, of, tap } from 'rxjs';
import { SnackbarService } from 'src/app/core/snackBar.notification.service';
import { SpinnerService } from 'src/app/core/spinner.service';
import { ProfileDetails } from 'src/app/models/profileDetails.model';
import { ProfileFlatNode } from 'src/app/models/profileFlatNode';
import { profileIndicator } from 'src/app/models/profileIndicator.model';
import { ProfileNode } from 'src/app/models/profileNode';
import { Util } from 'src/app/util/Util';

import { ProfileService } from '../services/profile.service';
import { UserProfileService } from '@services/userProfile.service';
import { AccessPermission } from 'src/app/models/userProfile.model';
import { DriveTimeService } from '@services/drivetime/drivetime.service';
import { createProfileMetadata } from './create-profile-metadata';
import {
  ConfirmDialogComponent,
  ConfirmDialogConfig,
} from 'src/app/shared/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NewCompanyDialogComponent } from './new-company-dialog/new-company-dialog.component';

@Injectable()
export class ChecklistDatabase {
  dataChange = new BehaviorSubject<ProfileNode[]>([]);
  editMode = false;
  get data(): ProfileNode[] {
    return this.dataChange.value;
  }
  // sampleProfile: string = '[ { "Node": { "Labor Supply" :70 }, "childNodes": [ { "Node": { "Availability and Quality": 40 }, "childNodes": [ { "Node": { "Demographics": 40 }, "childNodes": [ { "Labor Force": 25 }, { "Unemployment Rate (Monthly)": 25 }, { "Project Population Growth": 25 }, { "%Professional, Scientific & Tech Services": 25 } ] }, { "Node": { "Education": 50 }, "childNodes": [ { "% Bachelor\'s Degree": 40 }, { "% Master\'s Degree": 20 }, { "% Doctoral Degree": 20 }, { "Total 4-Year College Enrollment": 20 } ] }, { "Node": { "Degree Completions per 10,000 ppl age 18-64": 10 }, "childNodes": [ { "Computer and Information Sciences and Support Services - Bachelors degree": 30 }, { "Computer and Information Sciences and Support Services - Doctor\'s degree": 20 }, { "Mathematics and Statistics - Bachelors degree": 30 }, { "Mathematics and Statistics - Doctor\'s degree": 20 } ] } ] }, { "Node": { "Skill Set Employers per 10,000 Workers": 30 }, "childNodes": [ { "Node": { "AI & Data Scientist Skills Density": 100 }, "childNodes": [ { "Computer and Mathematical Occupations - Density": 20 }, { "Computer and Information Research Scientists - Density": 20 }, { "Software Developers and Software Quality Assurance Analysts and Testers - Density": 20 }, { "Mathematicians - Density": 20 }, { "Statisticians - Density": 20 } ] } ] },{ "Node": { "Skill Set Count": 30 }, "childNodes": [ { "Node": { "AI & Data Scientist Skills Count": 100 }, "childNodes": [ { "Computer and Mathematical Occupations - Count": 20 }, { "Computer and Information Research Scientists - Count": 20 }, { "Software Developers and Software Quality Assurance Analysts and Testers - Count": 20 }, { "Mathematicians - Count": 20 }, { "Statisticians - Count": 20 } ] } ] }]  }, { "Node": { "Labor Cost": 30 }, "childNodes": [ { "Node": { "Macro Labor Costs": 10 }, "childNodes": [ { "Median Home Value": 25 }, { "ERI Cost of Living": 75 } ] }, { "Node": { "Cost Skill Sets": 90 }, "childNodes": [ { "Node": { "AI & Data Scientist Skills": 100 }, "childNodes": [ { "Data Analyst - 5 Year": 20 }, { "Computer Software Engineer - 5 Year": 20 }, { "Statistician - 5 Year": 20 }, { "Software Developer - 5 Year": 20 }, { "Mathematician - 5 Year": 20 }  ] } ] } ] } ]';
  // profileDatapoints = '';

  constructor() {
    this.initialize();
  }

  convertToProfile(json: string | any[]) {
    if (json != '') {
      const details: ProfileNode[] = [];
      // json.forEach((element: any) => {
      //   let temp = this.convert(element, 1, 100);
      //   details.push(temp);
      // });
      // console.log(details)

      return details;
    } else {
      return [];
    }
  }

  convert(obj: any, level: number, effectiveWigtht: number) {
    const node = new ProfileNode();

    if (obj.childNodes === undefined) {
      const leafNodeName = Object.keys(obj)[0];
      node.name = leafNodeName;
      node.weight = obj[leafNodeName];
      node.effectiveWeight = (node.weight * effectiveWigtht) / 100;
    } else {
      const nodeObject = obj['Node'];
      const parentNodeName = Object.keys(nodeObject)[0];
      node.name = parentNodeName;
      node.weight = nodeObject[parentNodeName];
      node.effectiveWeight = (node.weight * effectiveWigtht) / 100;
      const children = obj['childNodes'];
      node.children = [];

      children.forEach((element: any) => {
        const tempNode = this.convert(element, level + 1, node.effectiveWeight);
        node.children.push(tempNode);
      });
    }

    // node.level = level;
    return node;
  }

  initialize() {
    const data = this.convertToProfile('');
    // Notify the change.
    this.dataChange.next(data);
  }

  initializeProfile(data) {
    // const data = this.convertToProfile(profileJson);
    // this.dataChange.next(null);
    this.dataChange.next(data);
  }

  /** Add an item to the profile parent nodes */
  insertItem(parent: ProfileNode, profileNode: ProfileNode) {
    if (parent.children) {
      parent.children.push(profileNode);
      this.weightagedistribution(parent);
    } else {
      parent.children = [];
      parent.children.push(profileNode);
    }
    this.dataChange.next(this.data);
  }

  weightagedistribution(parent: ProfileNode) {
    if (!this.editMode && parent.children != undefined) {
      parent.children.forEach((el) => {
        el.weight = (100 / parent.children.length).toFixed(2);
        el.effectiveWeight = (parent.effectiveWeight * el.weight) / 100;
      });
    }
  }

  /** Add an items from  group to a node */
  insertSupplyGroupItems(parent: ProfileNode, items: profileIndicator[], dropdownOptions: profileIndicator[]) {
    const profileNodes: ProfileNode[] = [];

    items.forEach((item, index) => {
      const profileNode = new ProfileNode();
      profileNode.expandable = false;
      profileNode.name = item.indicatorName;
      profileNode.weight = Number((item.percent * 100).toFixed(2));
      profileNode.effectiveWeight = (parent.effectiveWeight * profileNode.weight) / 100;
      profileNode.dropdownOptions = dropdownOptions;
      profileNode.filteredOptions = dropdownOptions;
      profileNode.id = item.id;
      profileNode.nodeId = parent.nodeId + '/' + index;
      profileNodes.push(profileNode);
    });

    parent.children = profileNodes;
    this.dataChange.next(this.data);
  }

  generateNodeId(profileNodes: ProfileNode[]) {
    const parentNodeCount = profileNodes.length;
    if (parentNodeCount === undefined || parentNodeCount === 0) return 0;
    const lastNode = profileNodes[parentNodeCount - 1];
    const nodeLevel = lastNode.nodeId;
    const targetIndex = nodeLevel.lastIndexOf('/') + 1;
    const count = Number.parseInt(nodeLevel.slice(targetIndex));
    if (Number.isNaN(count)) return 0;
    return count + 1;
  }

  insertFirstLevelItem(dataPointsAtFirstLevel: profileIndicator[]) {
    const profileObject: ProfileNode[] = this.data;
    const firstLevelNode = new ProfileNode();
    firstLevelNode.name = '';
    firstLevelNode.weight = '';
    firstLevelNode.isLeafNode = false;
    firstLevelNode.effectiveWeight = '';
    firstLevelNode.dropdownOptions = dataPointsAtFirstLevel;
    firstLevelNode.filteredOptions = dataPointsAtFirstLevel;
    const nodeId = '0/' + this.generateNodeId(profileObject);
    firstLevelNode.nodeId = nodeId;
    profileObject.push(firstLevelNode);
    this.dataChange.next(profileObject);
  }

  setDataPointValue(event: any) {
    console.log(event);
  }

  updateItem(node: ProfileNode, name: string) {
    node.name = name;
    this.dataChange.next(this.data);
  }

  refreshTree() {
    this.dataChange.next(this.data);
  }

  public deleteItem(parent: ProfileNode, flatNode: ProfileFlatNode): void {
    if (parent.children) {
      parent.children = parent.children.filter((c) => c.nodeId !== flatNode.nodeId);
      this.weightagedistribution(parent);
      this.dataChange.next(this.data);
    }
  }

  public deleteAllChildren(node: ProfileNode) {
    if (node.children) {
      node.children = [];
      this.dataChange.next(this.data);
    }
  }

  public deleteRootItem(node: ProfileFlatNode) {
    const data = this.data.filter((item) => item.nodeId !== node.nodeId);
    this.dataChange.next(data);
  }
}

export type profileSaveType = 'open' | 'close';

@Component({
  selector: 'app-create-profile',
  templateUrl: './create-profile.component.html',
  styleUrls: ['./create-profile.component.scss'],
  providers: [ChecklistDatabase],
})
export class CreateProfileComponent implements OnInit, OnDestroy {
  isInternalNameReadOnly = false;
  supplyGroups = [];
  public createProfileMetadata: any;

  countryCode = 73; // this is for USA. Change this when other countries have to be supported.

  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  //  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();
  flatNodeMap = new Map<ProfileFlatNode, ProfileNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  //  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();
  nestedNodeMap = new Map<ProfileNode, ProfileFlatNode>();

  /** A selected parent node to be inserted */
  //  selectedParent: TodoItemFlatNode | null = null;
  selectedParent: ProfileFlatNode | null = null;

  /** The new item's name */
  newItemName = '';

  //  treeControl: FlatTreeControl<TodoItemFlatNode>;
  treeControl: FlatTreeControl<ProfileFlatNode>;

  //  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;
  treeFlattener: MatTreeFlattener<ProfileNode, ProfileFlatNode>;

  //  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;
  dataSource: MatTreeFlatDataSource<ProfileNode, ProfileFlatNode>;

  /** The selection for checklist */
  //  checklistSelection = new SelectionModel<TodoItemFlatNode>(true /* multiple */);
  checklistSelection = new SelectionModel<ProfileFlatNode>(true /* multiple */);

  profileMetaData: any;

  parentNodeId: any;
  clientList: any;
  clientIds: any;
  externalNameSubscription: any;
  isClineNameChosen = false;

  // @ViewChild('search', {static: false}) searchBox: ElementRef;

  constructor(
    private fb: FormBuilder,
    private _database: ChecklistDatabase,
    private profileService: ProfileService,
    private spinnerService: SpinnerService,
    private matDialogSerice: MatDialog,
    private snackBarService: SnackbarService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private userProfileService: UserProfileService,
    private util: Util,
    private drivetimeService: DriveTimeService,
  ) {
    this.treeFlattener = new MatTreeFlattener(this.transformer, this.getLevel, this.isExpandable, this.getChildren);
    this.treeControl = new FlatTreeControl<ProfileFlatNode>(this.getLevel, this.isExpandable);
    this.dataSource = new MatTreeFlatDataSource(this.treeControl, this.treeFlattener);

    _database.dataChange.subscribe((data) => {
      this.dataSource.data = data;
    });
  }

  //  getLevel = (node: TodoItemFlatNode) => node.level;
  getLevel = (node: ProfileFlatNode) => node.level;

  //  isExpandable = (node: TodoItemFlatNode) => node.expandable;
  isExpandable = (node: ProfileFlatNode) => node.expandable;

  //  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;
  getChildren = (node: ProfileNode): ProfileNode[] => node.children;

  hasChild = (_: number, _nodeData: ProfileFlatNode) => _nodeData.expandable;

  hasNoChild = (_: number, _nodeData: ProfileFlatNode) => !_nodeData.expandable;

  hasSupplyGroup = (_: number, _nodeData: ProfileFlatNode) => _nodeData.isSupplyGroup;

  hasCostGroup = (_: number, _nodeData: ProfileFlatNode) => _nodeData.isCostGroup;

  hasDegreeCompletions = (_: number, _nodeData: ProfileFlatNode) => _nodeData.isDegreeCompletionGroup;

  hasSkillsGroup = (_: number, _nodeData: ProfileFlatNode) => _nodeData.isSkillsGroup;

  //  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.item === '';
  hasNoContent = (_: number, _nodeData: ProfileFlatNode) => !_nodeData.children;

  hasOccupationData = (_: number, _nodeData: ProfileFlatNode) => _nodeData.isOccupationGroup;

  transformer = (node: ProfileNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode = existingNode && existingNode.name === node.name ? existingNode : new ProfileFlatNode();
    flatNode.name = node.name;
    flatNode.weight = node.weight;
    flatNode.effectiveWeight = node.effectiveWeight;
    flatNode.level = level;
    flatNode.dropdownOptions = node.dropdownOptions;
    flatNode.filteredOptions = node.filteredOptions;
    flatNode.isSupplyGroup = node.isSupplyGroup;
    flatNode.isOccupationGroup = node.isOccupationGroup;
    flatNode.isCostGroup = node.isCostGroup;
    flatNode.groupCustomName = node.groupCustomName;
    flatNode.isDegreeCompletionGroup = node.isDegreeCompletionGroup;
    flatNode.isCompetitionResearchGroup = node.isCompetitionResearchGroup;
    flatNode.isSkillsGroup = node.isSkillsGroup;
    flatNode.degrees = node.degrees;
    flatNode.filteredDegrees = node.filteredDegrees;
    flatNode.secondDropdownOptions = node.secondDropdownOptions;
    flatNode.secondDropdownFilteredOptions = node.secondDropdownFilteredOptions;
    flatNode.secondName = node.secondName;
    flatNode.validationFailure = node.validationFailure;
    flatNode.nodeId = node.nodeId;
    flatNode.indicatorType = node.indicatorType;
    flatNode.expandable = node.children != undefined && node.children.length > 0 ? true : false;
    flatNode.isLeafNode = node.isLeafNode;
    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };

  profileForm: FormGroup;
  submitted = false;

  color: ThemePalette = 'primary';
  checked = false;
  disabled = false;

  isFavorite = false;

  editMode = false;
  profileId: string = null;
  profileDetails: ProfileDetails;
  allProfiles: ProfileDetails[];

  pageTitle = 'Create a Profile';

  formModified = false;
  profileLoadedInEditMode: any;
  profileValidationFailure = false;
  profileNoChanges = false;
  profileValidationErrors: string[] = [];

  // expansion model tracks expansion state
  expansionModel = new SelectionModel<string>(true);
  dragging = false;
  expandTimeout: any;
  expandDelay = 1000;
  selectedCountry = [];
  isCanadaDisable = true;

  ngOnInit() {
    this.createProfileMetadata = createProfileMetadata;
    if (this.userProfileService.can(AccessPermission.ADD_EDIT, 'profiles') === false) {
      return this.router.navigate(['/']);
    }
    this.activatedRoute.data.subscribe((data: { profileMetaData: any }) => {
      this.profileMetaData = data.profileMetaData;
    });

    this.loadAllProfiles();
    this.buildForm();
    this.getClients();
    this.profileForm.valueChanges.subscribe((value) => {
      this.formModified = true;
    });

    if (!this.selectedCountry || this.selectedCountry.length === 0) {
      this.selectedCountry = ['USA'];
    }

    this.externalNameSubscription = this.profileForm.get('externalProfileName').valueChanges.subscribe((val) => {
      if (this.isInternalNameReadOnly) {
        this.profileForm.get('internalProfileName').setValue(val);
      }
    });
    this.spinnerService.hide();
  }

  ngOnDestroy() {
    this.dataSource.disconnect(); // this will clean up the tree for next use...
    this._database.dataChange.unsubscribe();
    this.externalNameSubscription.unsubscribe();
  }

  getClients(newCompanyId?: number) {
    this.drivetimeService.getClients().subscribe((clients) => {
      this.clientList = clients.map((client) => ({
        id: client.id,
        name: client.name,
      }));
      this.createProfileMetadata.client = {
        ...this.createProfileMetadata.client,
        options: this.clientList,
      };
      this.checkEditMode();
      if (this.editMode) {
        this.loadProfileDetails();
      }

      if (newCompanyId) {
        this.setClientsForProfiles(newCompanyId.toString());
      }
    });
  }

  checkEditMode() {
    this.activatedRoute.params.subscribe((value) => {
      if (value.id !== undefined) {
        this.editMode = true;
        this.profileId = value.id;
        this.pageTitle = 'Edit Profile';
        this._database.editMode = true;
      }
    });
  }

  loadAllProfiles() {
    this.profileService.getAllProfiles().subscribe(
      (response) => {
        this.allProfiles = response;
      },
      (error) => {
        console.error('Drive-Time: Profilewizard -> loadAllProfiles -> error', error);
        this.spinnerService.hide();
        this.snackBarService.showError('Profiles could not be loaded. Please reach out to support team.');
      },
    );
  }

  loadProfileDetails() {
    this.spinnerService.show(' Loading profile details...');
    this.profileService.getProfileDetails(this.profileId).subscribe(
      (response) => {
        if (response.visibleInBenchmark === true && response.visibleInMultiSite === false) {
          this.isCanadaDisable = false;
        }
        this.profileDetails = response;
        this.updateForm();
        this.selectedCountry = response.countryCodes;
        this.setProfileMetaData(response.countryCodes);
        this.setClientsForProfiles(response.clientIds);
        // extract exact profile data points
        const jsonProfile = JSON.parse(this.profileDetails.profileDatapoints);
        const profileKeyName = Object.keys(jsonProfile)[0];
        const dataPoints = jsonProfile[profileKeyName];
        this.setEditProfileTree(dataPoints);
        // make a copy of the displayed profile to detech changes later on when saving
        this.profileLoadedInEditMode = JSON.parse(JSON.stringify(this.dataSource.data)); // deep copy
        this.spinnerService.hide();
      },
      (error) => {
        console.error('Drive-Time: Profilewizard -> loadProfile -> error', error);
        this.spinnerService.hide();
        this.snackBarService.showError('Profile could not be loaded. Please reach out to support team.');
      },
    );
  }

  private setClientsForProfiles(data: any): void {
    if (data) {
      let matchingOptions = [];
      data?.forEach((option) => {
        this.createProfileMetadata.client?.options.find((obj) => {
          if (obj.id === option) {
            matchingOptions.push(obj);
          }
        });
      });
      this.profileForm.controls.client.patchValue(matchingOptions);
    }
  }

  buildForm() {
    this.profileForm = this.fb.group({
      client: [null, Validators.required],
      externalProfileName: [null, Validators.required],
      internalProfileName: [null, null],
      sameAsInternalName: [null, null],
      linkToMultiSite: [true, null],
      linkToBenchmark: [true, null],
      linkToGeoskill: [false, null],
      linkToCountry: [null, null],
      isActive: [true, null],
    });
  }

  updateForm() {
    this.profileForm.patchValue({
      externalProfileName: this.profileDetails.profileName,
      internalProfileName: this.profileDetails.internalNotes,
      sameAsInternalName: false,
      linkToMultiSite: this.profileDetails.visibleInMultiSite,
      linkToBenchmark: this.profileDetails.visibleInBenchmark,
      linkToGeoskill: this.profileDetails.visibleInGeoskill,
      linkToCountry: this.profileDetails.countryCodes || '',
      isActive: this.profileDetails.active,
    });
    this.isFavorite = this.profileDetails.defaultProfile;
  }

  onContryChange(contry: string, event: MatCheckboxChange): void {
    if (event.checked) {
      this.selectedCountry.push(contry);
    } else {
      this.selectedCountry = this.selectedCountry.filter((c) => c !== contry);
    }

    this.profileForm.patchValue({ linkToCountry: this.selectedCountry });
    this.setProfileMetaData(this.selectedCountry);
    this.clearAllIndicator();
  }

  clearAllIndicator(): void {
    this.flatNodeMap.clear();
    this._database.dataChange.next([]);
  }

  setProfileMetaData(country) {
    this.profileService.getProfileMetaData(country).subscribe((indicator) => (this.profileMetaData = indicator));
  }

  get registerFormControl() {
    return this.profileForm.controls;
  }

  setFavorite() {
    this.isFavorite = !this.isFavorite;
  }

  /** Whether all the descendants of the node are selected. */
  descendantsAllSelected(node: ProfileFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every((child) => {
        return this.checklistSelection.isSelected(child);
      });
    return descAllSelected;
  }

  /** Whether part of the descendants are selected */
  descendantsPartiallySelected(node: ProfileFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some((child) => this.checklistSelection.isSelected(child));
    return result && !this.descendantsAllSelected(node);
  }

  /** Toggle the to-do item selection. Select/deselect all the descendants node */
  todoItemSelectionToggle(node: ProfileFlatNode): void {
    this.checklistSelection.toggle(node);
    const descendants = this.treeControl.getDescendants(node);
    this.checklistSelection.isSelected(node)
      ? this.checklistSelection.select(...descendants)
      : this.checklistSelection.deselect(...descendants);

    // Force update for the parent
    descendants.forEach((child) => this.checklistSelection.isSelected(child));
    this.checkAllParentsSelection(node);
  }

  /** Toggle a leaf to-do item selection. Check all the parents to see if they changed */
  todoLeafItemSelectionToggle(node: ProfileFlatNode): void {
    this.checklistSelection.toggle(node);
    this.checkAllParentsSelection(node);
  }

  /* Checks all the parents when a leaf node is selected/unselected */
  checkAllParentsSelection(node: ProfileFlatNode): void {
    let parent: ProfileFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  /** Check root node checked state and change it accordingly */
  checkRootNodeSelection(node: ProfileFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected =
      descendants.length > 0 &&
      descendants.every((child) => {
        return this.checklistSelection.isSelected(child);
      });
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  /* Get the parent node of a node */
  getParentNode(node: ProfileFlatNode): ProfileFlatNode | null {
    const currentLevel = this.getLevel(node);

    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }

  /** Select the category so we can insert the new item. */
  addNewItem(node: ProfileFlatNode) {
    if (node.name === '')
      // if the current node has no data point selected then dont add the new node under it...
      return;
    const parentNode = this.flatNodeMap.get(node);
    this.parentNodeId = parentNode.id;
    let availableDataPoints = [];
    let weight = '';
    if (!this.editMode) {
      weight = '100';
    }

    const profileNode = new ProfileNode();
    profileNode.name = '';
    profileNode.weight = weight;
    profileNode.effectiveWeight = (parentNode.effectiveWeight * profileNode.weight) / 100;
    const childNodes = parentNode.children || [];
    const nodeId = this._database.generateNodeId(childNodes);
    profileNode.nodeId = parentNode.nodeId + '/' + nodeId;

    if (parentNode.id == 39 || parentNode.id == 51 || parentNode.id == 1179 || parentNode.id == 1178) {
      availableDataPoints = this.getSupplyGroups(this.countryCode);

      profileNode.isSupplyGroup = true;
      profileNode.groupCustomName = '';
      profileNode.dropdownOptions = availableDataPoints;
      profileNode.filteredOptions = availableDataPoints;

      this._database.insertItem(parentNode!, profileNode);
    } else if (parentNode.id == 99 || parentNode.id == 1146) {
      profileNode.isDegreeCompletionGroup = true;

      const degreeItems = this.getDegrees();
      profileNode.degrees = degreeItems;
      profileNode.filteredDegrees = degreeItems;

      profileNode.secondDropdownOptions = this.getDegreeLevels(this.countryCode);
      profileNode.secondName = '';

      this._database.insertItem(parentNode!, profileNode);
    } else if (parentNode.id == 50 || parentNode.id == 67 || parentNode.id == 68 || parentNode.id == 69) {
      availableDataPoints = this.getCostGroups(this.countryCode);

      profileNode.isCostGroup = true; // reusing whats created for supply group for cost group.
      profileNode.groupCustomName = '';
      profileNode.dropdownOptions = availableDataPoints;
      profileNode.filteredOptions = availableDataPoints;

      this._database.insertItem(parentNode!, profileNode);
    } else if (parentNode.id == 757) {
      availableDataPoints = this.getCompetitionReasechItems(this.countryCode);

      profileNode.name = '';
      profileNode.isCompetitionResearchGroup = true;
      profileNode.dropdownOptions = availableDataPoints;
      profileNode.filteredOptions = availableDataPoints;

      this._database.insertItem(parentNode!, profileNode);
    } else if (parentNode.isCompetitionResearchGroup != undefined && parentNode.isCompetitionResearchGroup) {
      availableDataPoints = this.getCompetitionReasechDropDownItems(this.countryCode);
      profileNode.filteredOptions = availableDataPoints;
      profileNode.dropdownOptions = availableDataPoints;
      this._database.insertItem(parentNode!, profileNode);
    } else if (parentNode.id == 1147 || parentNode.id == 1151 || parentNode.id == 1157 || parentNode.id == 1180 || parentNode.id == 1181) {
      // Skills / Labor Demand Compeitiion / Diversity and Inclusion are lumped togeather as isSkillsGroup as they all have to support linked in data points..

      profileNode.isSkillsGroup = true;

      const secondIndicator = this.profileMetaData.indicators.profile.filter(
        (item) => item.indicatorName === parentNode.name,
      );
      if (!this.selectedCountry.includes('CAN')) {
        availableDataPoints = this.getDataPointsForLevel(parentNode.id, this.countryCode);
      } else {
        availableDataPoints = secondIndicator.flatMap((indicator) =>
          this.getDataPointsForLevel(indicator.id, indicator.countryId),
        );
      }
      // availableDataPoints = this.getDataPointsForLevel(parentNode.id, this.countryCode);
      profileNode.filteredOptions = availableDataPoints;
      profileNode.dropdownOptions = availableDataPoints;

      const secondDropdownListItems = this.getLinkedInSkills(this.countryCode);
      profileNode.secondDropdownFilteredOptions = secondDropdownListItems;
      profileNode.secondDropdownOptions = secondDropdownListItems;
      profileNode.secondName = '';

      this._database.insertItem(parentNode!, profileNode);
    } else if (parentNode.id == 1165) {
      profileNode.isLeafNode = true;
      profileNode.isOccupationGroup = true;

      availableDataPoints = this.getOccupationGroupItems(parentNode.id, this.countryCode);
      profileNode.filteredOptions = availableDataPoints;
      profileNode.dropdownOptions = availableDataPoints;

      const secondDropdownListItems: any = this.getOccupationDiversityGroupItems(parentNode.id, this.countryCode);
      profileNode.secondDropdownFilteredOptions = secondDropdownListItems;
      profileNode.secondDropdownOptions = secondDropdownListItems;

      this._database.insertItem(parentNode!, profileNode);
    } else if (parentNode.id == 1166) {
      profileNode.isLeafNode = true;
      profileNode.isOccupationGroup = true;

      availableDataPoints = this.getOccupationGroupItems(parentNode.id, this.countryCode);
      profileNode.filteredOptions = availableDataPoints;
      profileNode.dropdownOptions = availableDataPoints;

      const secondDropdownListItems: any = this.getOccupationDiversityGroupItems(parentNode.id, this.countryCode);
      profileNode.secondDropdownFilteredOptions = secondDropdownListItems;
      profileNode.secondDropdownOptions = secondDropdownListItems;

      this._database.insertItem(parentNode!, profileNode);
    } else if (parentNode.id === 1164) {
      profileNode.isLeafNode = true;
      profileNode.isSupplyGroup = false;
      availableDataPoints = this.getOccupationGroupItems(parentNode.id, this.countryCode);
      profileNode.filteredOptions = availableDataPoints;
      profileNode.dropdownOptions = availableDataPoints;
      this._database.insertItem(parentNode!, profileNode);
    } else {
      const secondIndicator = this.profileMetaData.indicators.profile.filter(
        (item) => item.indicatorName === parentNode.name,
      );

      if (!this.selectedCountry.includes('CAN')) {
        availableDataPoints = this.getDataPointsForLevel(parentNode.id, this.countryCode);
      } else {
        availableDataPoints = secondIndicator.flatMap((indicator) =>
          this.getDataPointsForLevel(indicator.id, indicator.countryId),
        );
      }

      availableDataPoints = this.sortDropdownList(availableDataPoints);

      profileNode.isSupplyGroup = false;
      profileNode.groupCustomName = '';
      profileNode.dropdownOptions = availableDataPoints;
      profileNode.filteredOptions = availableDataPoints;

      // //Set Add button status based on whether a data point is a category or a leaf node
      // let childDataPoints = this.getDataPointsForLevel(profileNode.id, this.countryCode);
      // if (childDataPoints != undefined && childDataPoints.length > 0){
      //   profileNode.isLeafNode = false;
      // } else {
      //   profileNode.isLeafNode = true;
      // }

      this._database.insertItem(parentNode!, profileNode);
      // }
    }

    this.expansionModel.select(profileNode.nodeId); // add the node to the expansion panel

    this.refreshTree(node);
    this.expandFlatNode(node);
  }

  addCompetitionResearchItems(node: ProfileFlatNode) {
    const parentNode = this.flatNodeMap.get(node);
    let availableDataPoints = [];

    const profileNode = new ProfileNode();
    profileNode.name = '';
    profileNode.weight = '';
    profileNode.effectiveWeight = '';
    profileNode.isLeafNode = true;

    availableDataPoints = this.getCompetitionReasechDropDownItems(this.countryCode);

    profileNode.filteredOptions = availableDataPoints;

    this._database.insertItem(parentNode!, profileNode);

    this.refreshTree(node);
    this.expandFlatNode(node);
  }

  addSupplyGroupItems(node: ProfileFlatNode, indicatorNode: profileIndicator, event: any) {
    if (event.isUserInput) {
      const parentNode = this.flatNodeMap.get(node);
      parentNode.name = indicatorNode.indicatorName;
      parentNode.groupCustomName = indicatorNode.indicatorName;
      const supplyGroupItems = this.getSupplyGroupItems(indicatorNode, this.countryCode);
      // let supplyGroupItemDropDownOptions = this.profileMetaData.indicators.occupations.filter((indicator: { countryId: number; }) => indicator.countryId === this.countryCode);
      let supplyGroupItemDropDownOptions = this.getSupplyGroupOccupations();
      supplyGroupItemDropDownOptions = this.sortDropdownList(supplyGroupItemDropDownOptions);
      this._database.insertSupplyGroupItems(parentNode, supplyGroupItems, supplyGroupItemDropDownOptions);

      this.expansionModel.select(parentNode.nodeId); // add the node to the expansion panel

      this.refreshTree(node);
      this.expandFlatNode(this.nestedNodeMap.get(parentNode));
    }
  }

  addSupplyGroupItem(node: ProfileFlatNode) {
    const parentNode = this.flatNodeMap.get(node);
    let occupations = this.getSupplyGroupOccupations();
    occupations = this.sortDropdownList(occupations);

    const profileNode = new ProfileNode();

    profileNode.isSupplyGroup = false;
    profileNode.groupCustomName = '';
    profileNode.name = '';
    profileNode.weight = '';
    profileNode.effectiveWeight = '';
    profileNode.isLeafNode = true;
    profileNode.dropdownOptions = occupations;
    profileNode.filteredOptions = occupations;
    const childNodes = parentNode.children || [];
    const nodeId = this._database.generateNodeId(childNodes);
    profileNode.nodeId = parentNode.nodeId + '/' + nodeId;

    this._database.insertItem(parentNode!, profileNode);

    this.refreshTree(node);
    this.expandFlatNode(node);
  }

  getSupplyGroupOccupations() {
    return this.profileMetaData.indicators.occupations.filter(
      (indicator: { countryId: number }) => indicator.countryId === this.countryCode,
    );
  }

  addCostGroupItems(node: ProfileFlatNode, indicatorNode: profileIndicator, event: any) {
    if (event.isUserInput) {
      const parentNode = this.flatNodeMap.get(node);
      parentNode.name = indicatorNode.indicatorName;
      parentNode.groupCustomName = indicatorNode.indicatorName;
      const costGroupItems = this.getCostGroupItems(indicatorNode, this.countryCode);
      let costGroupItemDropDownOptions = this.profileMetaData.indicators.costOccupations;
      costGroupItemDropDownOptions = this.sortDropdownList(costGroupItemDropDownOptions);
      this._database.insertSupplyGroupItems(parentNode, costGroupItems, costGroupItemDropDownOptions);

      this.refreshTree(node);
      this.expandFlatNode(this.nestedNodeMap.get(parentNode));
    }
  }

  addCostGroupItem(node: ProfileFlatNode) {
    const parentNode = this.flatNodeMap.get(node);
    let costGroupItemDropDownOptions = this.profileMetaData.indicators.costOccupations;
    costGroupItemDropDownOptions = this.sortDropdownList(costGroupItemDropDownOptions);

    const profileNode = new ProfileNode();

    profileNode.isSupplyGroup = false;
    profileNode.groupCustomName = '';
    profileNode.name = '';
    profileNode.weight = '';
    profileNode.effectiveWeight = '';
    profileNode.isLeafNode = true;
    profileNode.dropdownOptions = costGroupItemDropDownOptions;
    profileNode.filteredOptions = costGroupItemDropDownOptions;
    const childNodes = parentNode.children || [];
    const nodeId = this._database.generateNodeId(childNodes);
    profileNode.nodeId = parentNode.nodeId + '/' + nodeId;
    this._database.insertItem(parentNode!, profileNode);

    this.refreshTree(node);
    this.expandFlatNode(node);
  }

  /** Set Item weight. */
  setItemWeight(node: ProfileFlatNode, weight) {
    const currentNode = this.flatNodeMap.get(node);
    let parentNode = currentNode;

    if (this.getLevel(node) !== 0) {
      parentNode = this.getParentNode(node);
      currentNode.weight = weight;
      // currentNode.effectiveWeight = parentNode.effectiveWeight * weight/100;
      this.recalculateEffectiveWeights(currentNode, parentNode.effectiveWeight);
      // this.treeControl.expand(node);
    } else {
      parentNode.weight = weight;
      parentNode.effectiveWeight = weight;
      this.recalculateEffectiveWeights(currentNode, 100);
      // this.treeControl.expand(node);
    }
    this.refreshTree(node);
    this.restoreExpansionPanel();
    // console.log(weight);
  }

  /** Save the node to database */
  saveNode(node: ProfileFlatNode, itemValue: string) {
    const nestedNode = this.flatNodeMap.get(node);
    this._database.updateItem(nestedNode!, itemValue);
  }

  /** remove node to database */
  deleteNode(node: ProfileFlatNode) {
    if (this.getLevel(node) !== 0) {
      const parentNode = this.getParentNode(node);
      const parentFlatNode = this.flatNodeMap.get(parentNode);
      this._database.deleteItem(parentFlatNode!, node);
    } else {
      const targetName = node.name;

      for (const [key, value] of this.flatNodeMap.entries()) {
        if (value.name === targetName && (!key.name || key.name === targetName)) {
          this.flatNodeMap.delete(key);
        }
      }
      this._database.deleteRootItem(node);
    }

    this.refreshTree(node);
    this.restoreExpansionPanel();
  }

  /** Recalculate all effective weights */
  recalculateEffectiveWeights(node: ProfileNode, parentEffectiveWeight) {
    node.effectiveWeight = (parentEffectiveWeight * node.weight) / 100;
    if (node.children != undefined && node.children.length > 0) {
      node.children.forEach((item) => {
        this.recalculateEffectiveWeights(item, node.effectiveWeight);
      });
    }
  }

  /** get profile creation meta data from api */
  getProfileCreationMetaData() {
    this.spinnerService.show(' Loading profile metadata...');
    this.profileService.getProfileMetaData(['USA']).subscribe(
      (response) => {
        this.profileMetaData = response;
        this.spinnerService.hide();
        console.log(' profile metadata : ' + response);
      },
      (error) => {
        console.error('Drive-Time: Profilewizard -> getProfileCreationMetaData -> error', error);
        this.spinnerService.hide();
      },
    );
  }

  addfirstLevelNode() {
    let firstLevelDataPoints = this.getDataPointsForLevel(null, this.countryCode);
    firstLevelDataPoints = this.sortDropdownList(firstLevelDataPoints);
    this._database.insertFirstLevelItem(firstLevelDataPoints);
    // add item to the selection panel
    this.expansionModel.select('0/' + (this.dataSource.data.length - 1));
  }

  onDataPointSelection(flatNode: ProfileFlatNode, indicator: profileIndicator, event: any) {
    const currentNode = this.flatNodeMap.get(flatNode);
    currentNode.countryId = indicator.countryId;
    if (!event.isUserInput || currentNode.name === indicator.indicatorName) {
      return; // dont proceed if there is no change detected yet.
    }

    if (
      currentNode.name !== '' &&
      currentNode.name !== indicator.indicatorName &&
      currentNode.children != undefined &&
      currentNode.children.length > 0
    ) {
      this.showConfirmation(currentNode, indicator);
    } else {
      currentNode.name = indicator.indicatorName;
      currentNode.id = indicator.id;
      currentNode.indicatorType = indicator.indicatorType;
      if (currentNode.indicatorType == 'LinkedIn') {
        // if the indicator type is linked in set the second dropdown values accordingly based on current item (Skill Vs Function)
        if (currentNode.id == 1162) {
          currentNode.secondDropdownOptions = this.getLinkedInFunctions(this.countryCode);
          currentNode.secondDropdownFilteredOptions = currentNode.secondDropdownOptions;
        } else if (
          currentNode.id === 1176 ||
          currentNode.id === 1177 ||
          currentNode.id === 1175 ||
          currentNode.id === 1170 ||
          currentNode.id === 1171 ||
          currentNode.id === 1172 ||
          currentNode.id === 1180 ||
          currentNode.id === 1181 ||
          currentNode.id === 1182 ||
          currentNode.id === 1183 ||
          currentNode.id === 1184 ||
          currentNode.id === 1185 ||
          currentNode.id === 1186 ||
          currentNode.id === 1187 ||
          currentNode.id === 1188 ||
          currentNode.id === 1189 ||
          currentNode.id === 1190 ||
          currentNode.id === 1191
        ) {
          currentNode.isSkillsGroup = true;
          currentNode.isLeafNode = true;
          currentNode.secondDropdownOptions = this.getLinkedInJobFunctions(this.countryCode);
          currentNode.secondDropdownFilteredOptions = currentNode.secondDropdownOptions;
        } else {
          currentNode.secondDropdownOptions = this.getLinkedInSkills(this.countryCode);
          currentNode.secondDropdownFilteredOptions = currentNode.secondDropdownOptions;
        }
      }

      //Set Add button status based on whether a data point is a category or a leaf node
      if (flatNode.isLeafNode != undefined) {
        currentNode.isLeafNode = flatNode.isLeafNode;
      } else {
        const childDataPoints = this.getDataPointsForLevel(currentNode.id, this.countryCode);
        if (this.isOneOfSpecialGroups(currentNode) || (childDataPoints != undefined && childDataPoints.length > 0)) {
          currentNode.isLeafNode = false;
        } else {
          currentNode.isLeafNode = true;
        }
      }

      this.refreshTree(flatNode);
      this.expandFlatNode(flatNode);
    }
  }

  onDegreeSelection(flatNode: ProfileFlatNode, degree: any, event: any) {
    if (event.isUserInput) {
      const currentNode = this.flatNodeMap.get(flatNode);
      currentNode.name = degree.name;
      this.refreshTree(flatNode);
    }
  }

  onDegreeLevelSelection(flatNode: ProfileFlatNode, degree: profileIndicator, event: any) {
    if (event.isUserInput) {
      const currentNode = this.flatNodeMap.get(flatNode);
      currentNode.secondName = degree.indicatorName;
      this.refreshTree(flatNode);
    }
  }

  setGroupName(flatNode: ProfileFlatNode, name: string) {
    const currentNode = this.flatNodeMap.get(flatNode);
    currentNode.groupCustomName = name;
  }

  onLinkedInSkillSelection(flatNode: ProfileFlatNode, skill: profileIndicator, event: any) {
    if (event.isUserInput) {
      const currentNode = this.flatNodeMap.get(flatNode);
      currentNode.secondName = skill.indicatorName;
      this.refreshTree(flatNode);
    }
  }

  onOccupationDiversitySelection(flatNode: ProfileFlatNode, supply: profileIndicator, event: any) {
    if (event.isUserInput) {
      const currentNode = this.flatNodeMap.get(flatNode);
      currentNode.secondName = supply.indicatorName;
      this.refreshTree(flatNode);
    }
  }

  expandFlatNode(node: ProfileFlatNode) {
    if (node) {
      const index = this.treeControl.dataNodes.findIndex(
        (item) => item.level === node.level && item.name === node.name,
      );
      this.treeControl.expand(this.treeControl.dataNodes[index]);
    }
  }

  refreshTree(_node: ProfileFlatNode) {
    this._database.refreshTree();
  }

  getDataPointsForLevel(id: any, countryCode: number, name?: string) {
    let indicators: profileIndicator[] = [];

    if (!this.isCanadaDisable && this.selectedCountry.includes('CAN')) {
      if (this.editMode && name) {
        indicators = this.profileMetaData.indicators.profile.flatMap((parent) =>
          parent.indicatorName === name
            ? this.profileMetaData.indicators.profile.filter((child) => child.parentID === parent.id)
            : [],
        );
      } else {
        indicators = this.profileMetaData.indicators.profile.filter((indicator) =>
          id != null ? indicator.parentID === id : indicator.parentID === null,
        );
      }
    } else {
      if (id == null) {
        indicators = this.profileMetaData.indicators.profile.filter(
          (indicator: { parentID: any; countryId: number }) =>
            indicator.parentID === null && indicator.countryId === countryCode,
        );
      } else {
        // const profileNode = this.flatNodeMap.get(flatNode);
        indicators = this.profileMetaData.indicators.profile.filter(
          (indicator: { parentID: number; countryId: number }) =>
            indicator.parentID === id && indicator.countryId === countryCode,
        );
      }
    }
    return indicators;
  }

  getSupplyGroups(countryCode: number) {
    // const profileNode = this.flatNodeMap.get(flatNode);
    const tempList = this.profileMetaData.indicators.supplyGroup.filter(
      (supplyGroup: { countryId: any }) => supplyGroup.countryId === countryCode,
    );
    return this.sortDropdownList(tempList);
  }

  getCostGroups(_countryCode: number) {
    // return this.profileMetaData.indicators.costGroup.filter(costGroup => costGroup.countryId === countryCode );
    const tempList = this.profileMetaData.indicators.costGroup;
    return this.sortDropdownList(tempList);
  }

  getCompetitionReasechItems(countryCode: number) {
    return this.profileMetaData.indicators.competitionGroup.filter(
      (item: { countryId: any }) => item.countryId === countryCode,
    );
  }

  getCompetitionReasechDropDownItems(countryCode: number) {
    return this.profileMetaData.indicators.competitionDataPoints.filter(
      (item: { countryId: any }) => item.countryId === countryCode,
    );
  }

  getSupplyGroupItems(indicatorNode: profileIndicator, countryCode: number) {
    return this.profileMetaData.indicators.supplyGroupDataPoints.filter(
      (indicator: { parentID: number; countryId: number }) =>
        indicator.parentID === indicatorNode.id && indicator.countryId === countryCode,
    );
  }

  getCostGroupItems(indicatorNode: profileIndicator, _countryCode: number) {
    // return this.profileMetaData.indicators.costGroupDataPoints.filter(indicator => indicator.parentID === indicatorNode.id && indicator.countryId === countryCode );;
    return this.profileMetaData.indicators.costGroupDataPoints.filter(
      (indicator: { parentID: number }) => indicator.parentID === indicatorNode.id,
    );
  }

  getOccupationGroupItems(id: any, countryCode: number) {
    let indicators: profileIndicator[] = [];
    indicators = this.profileMetaData.indicators.occupationGroups.filter(
      (indicator: { countryId: number }) => indicator.countryId === countryCode,
    );
    // indicators = this.profileMetaData.indicators.occupationGroups;
    return indicators;
  }

  getOccupationDiversityGroupItems(id: any, countryCode: number) {
    let indicators: profileIndicator[] = [];
    indicators = this.profileMetaData.indicators.occupationDiversityGroups.filter(
      (indicator: { countryId: number }) => indicator.countryId === countryCode,
    );
    return indicators;
  }

  getDegrees() {
    const parentDegrees = this.profileMetaData.indicators.degree.filter(
      (indicator: { parentID: any }) => indicator.parentID === null,
    ); // extract all parent degree levels (this is the group level)
    parentDegrees.sort((a: { indicatorName: string }, b: { indicatorName: any }) =>
      a.indicatorName.localeCompare(b.indicatorName),
    );
    const degreeGroups = [];
    parentDegrees.forEach((element: { id: any; indicatorName: any }) => {
      const groupItems = this.profileMetaData.indicators.degree.filter(
        (indicator: { parentID: any }) => indicator.parentID === element.id,
      );
      groupItems.sort((a: { indicatorName: string }, b: { indicatorName: any }) =>
        a.indicatorName.localeCompare(b.indicatorName),
      );
      degreeGroups.push({
        name: element.indicatorName,
        isParent: true,
      });
      groupItems.forEach((element: { indicatorName: any }) => {
        degreeGroups.push({
          name: element.indicatorName,
          isParent: false,
        });
      });
    });
    return degreeGroups;
  }

  getDegreeLevels(_countryCode: number) {
    return this.profileMetaData.indicators.degreeLevel;
  }

  getLinkedInSkills(_countryCode: number) {
    const tempList = this.profileMetaData.indicators.linkedInSkills;
    return this.sortDropdownList(tempList);
  }

  getLinkedInJobFunctions(_countryCode: number) {
    const tempList = this.profileMetaData.indicators.linkedInJobFunctions;
    return this.sortDropdownList(tempList);
  }

  getLinkedInFunctions(_countryCode: number) {
    const tempList = this.profileMetaData.indicators.linkedInFunctions;
    return this.sortDropdownList(tempList);
  }

  isLinkedInDataPoint(dataPoint: string) {
    let tempList = this.profileMetaData.indicators.linkedInSkills;
    tempList = tempList.concat(this.profileMetaData.indicators.linkedInFunctions);
    tempList = tempList.concat(this.profileMetaData.indicators.linkedInJobFunctions);
    let flag = false;
    tempList.forEach((skill) => {
      if (dataPoint.toLowerCase().includes('- ' + skill.indicatorName.toLowerCase())) {
        flag = true;
      }
    });
    return flag;
  }

  getSiblingSelections(flatNode: ProfileFlatNode): Set<string> {
    const selections = new Set<string>();

    if (flatNode.level === 0) {
      for (const flat of this.flatNodeMap.keys()) {
        const node = this.flatNodeMap.get(flat);
        if (flat.level === 0 && node?.name && (!flatNode.name || node.name !== flatNode.name)) {
          selections.add(node.name);
        }
      }
    } else {
      const parentFlatNode = this.getParentNode(flatNode);
      const parent = this.flatNodeMap.get(parentFlatNode);

      for (const child of parent?.children || []) {
        if (child.name && (!flatNode.name || child.name !== flatNode.name)) {
          selections.add(child.name);
        }
      }
    }

    return selections;
  }

  filterOptions(flatNode: ProfileFlatNode, value: { target: { value: string } }) {
    const currentNode = this.flatNodeMap.get(flatNode);
    let currentOptions = flatNode.dropdownOptions;
    const siblingLevelSelections = this.getSiblingSelections(flatNode);
    if (siblingLevelSelections.size > 0) {
      const updatedDropDownOption = currentOptions.filter((item) => !siblingLevelSelections.has(item.indicatorName)); // remove all sibling level selections from options
      currentOptions = updatedDropDownOption;
    }

    if (this.util.containsAlphaNumeric(value.target.value)) {
      const tempOptions = currentOptions.filter((option) =>
        option.indicatorName.toLowerCase().startsWith(value.target.value.toLowerCase()),
      );
      currentNode.filteredOptions = tempOptions;
    } else {
      currentNode.filteredOptions = currentOptions;
    }
    this.refreshTree(flatNode);
  }

  filterSecondDropdownOptions(flatNode: ProfileFlatNode, value: { target: { value: string } }) {
    const currentNode = this.flatNodeMap.get(flatNode);
    const currentOptions = flatNode.secondDropdownOptions;
    if (this.util.containsAlphaNumeric(value.target.value)) {
      const tempOptions = currentOptions.filter((option) =>
        option.indicatorName.toLowerCase().includes(value.target.value.toLowerCase()),
      );
      currentNode.secondDropdownFilteredOptions = tempOptions;
    } else {
      currentNode.secondDropdownFilteredOptions = currentOptions;
    }
    this.refreshTree(flatNode);
  }

  filterDegreeOptions(flatNode: ProfileFlatNode, value: { target: { value: string } }) {
    const currentNode = this.flatNodeMap.get(flatNode);
    if (this.util.containsAlphaNumeric(value.target.value)) {
      const tempOptions = currentNode.degrees.filter((option: { name: string }) =>
        option.name.toLowerCase().includes(value.target.value.toLowerCase()),
      );
      currentNode.filteredDegrees = tempOptions;
    } else {
      currentNode.filteredDegrees = currentNode.degrees;
    }
    this.refreshTree(flatNode);
  }

  groupIndicators(indicators: profileIndicator[]): {
    indicatorName: string;
    items: profileIndicator[];
    sourceIds: number[];
    representative: profileIndicator;
  }[] {
    const groupedMap = new Map<string, profileIndicator[]>();

    indicators.forEach((ind) => {
      const name = ind.indicatorName;
      if (!groupedMap.has(name)) groupedMap.set(name, []);
      groupedMap.get(name)!.push(ind);
    });

    return Array.from(groupedMap.entries()).map(([name, items]) => ({
      indicatorName: name,
      items,
      sourceIds: items.map((i) => i.id),
      representative: items[0],
    }));
  }

  isDuplicateAllowed(item: profileIndicator): boolean {
    const allowDuplicateByName = ['LinkedIn'];
    const allowDuplicateById = [1165, 1166, 1170, 1171, 1172];
    return (
      allowDuplicateByName.includes(item.indicatorName) ||
      allowDuplicateById.includes(item.id) ||
      item.indicatorType === 'LinkedIn'
    );
  }

  onOpen(flatNode: ProfileFlatNode, event: any): void {
    if (!event) return;

    const isCanadaOnly = this.selectedCountry.length === 1 && this.selectedCountry.includes('CAN');
    this.countryCode = isCanadaOnly ? 13 : 73;

    let parentSourceIds: number[] = [];

    if (flatNode.level > 0) {
      const parentFlatNode = this.getParentNode(flatNode);
      const parent = this.flatNodeMap.get(parentFlatNode);
      const parentName = parent?.name;

      if (parentName) {
        parentSourceIds = this.profileMetaData.indicators.profile
          .filter((i) => i.indicatorName === parentName)
          .map((i) => i.id);
      }
    }

    let allIndicators: profileIndicator[] = [];

    if (flatNode.isSupplyGroup) {
      allIndicators = this.profileMetaData.indicators.supplyGroup;
    } else if (flatNode.isCostGroup) {
      allIndicators = this.profileMetaData.indicators.costGroup;
    } else if (flatNode.isCompetitionResearchGroup) {
      allIndicators = this.profileMetaData.indicators.competitionResearchGroup;
    } else if (flatNode.isDegreeCompletionGroup) {
      allIndicators = this.profileMetaData.indicators.degree;
    } else if (flatNode.isOccupationGroup) {
      allIndicators = this.profileMetaData.indicators.occupationGroups;
    } else {
      allIndicators = this.profileMetaData.indicators.profile;

      if (this.selectedCountry.length === 2) {
        const nameMap = new Map<string, number>();
        for (const ind of allIndicators) {
          nameMap.set(ind.indicatorName, (nameMap.get(ind.indicatorName) || 0) + 1);
        }
        allIndicators = allIndicators.filter((i) => nameMap.get(i.indicatorName) > 1);
      }
    }

    const isFlatProfile = !(
      flatNode.isSupplyGroup ||
      flatNode.isCostGroup ||
      flatNode.isCompetitionResearchGroup ||
      flatNode.isDegreeCompletionGroup ||
      flatNode.isOccupationGroup
    );

    const currentOptions = isFlatProfile
      ? flatNode.level === 0
        ? allIndicators.filter((i) => i.parentID === null)
        : allIndicators.filter((i) => parentSourceIds.includes(i.parentID))
      : allIndicators;

    const siblingLevelSelections = this.getSiblingSelections(flatNode);

    const groupedOptions = this.groupIndicators(currentOptions);

    const filteredOptions = groupedOptions.filter((group) => {
      const first = group.items[0];
      const name = first.indicatorName;

      if (this.isDuplicateAllowed(first)) return true;
      return !siblingLevelSelections.has(name);
    });

    const sortedOptions = filteredOptions.sort((a, b) =>
      a.representative.indicatorName.localeCompare(b.representative.indicatorName),
    );

    const profileNode = this.flatNodeMap.get(flatNode) as ProfileFlatNode;
    profileNode.filteredOptions = sortedOptions.map((g) => g.representative);

    this.refreshTree(flatNode);
    this.restoreExpansionPanel();
  }

  onLinkedInSelection(flatNode: ProfileFlatNode, event: any) {
    if (event) {
      const usedSecondNames = this.getSiblingSelectionsForLinkedIn(flatNode);
      flatNode.secondDropdownFilteredOptions = flatNode.secondDropdownOptions.filter(
        (option) => !usedSecondNames.has(option.indicatorName.toLowerCase())
      );
    }
  }

  getSiblingSelectionsForLinkedIn(flatNode: ProfileFlatNode): Set<string> {
    const selections = new Set<string>();
    if (flatNode.level > 0) {
      const parentFlatNode = this.getParentNode(flatNode);
      if (parentFlatNode) {
        const parentNested = this.flatNodeMap.get(parentFlatNode);
        const currentNested = this.flatNodeMap.get(flatNode);
        const currentPrimary = (currentNested?.name || '').toLowerCase();

        if (!currentPrimary) return selections;

        if (parentNested?.children?.length) {
          for (const child of parentNested.children) {
            if (child !== currentNested &&
              (child.name || '').toLowerCase() === currentPrimary &&
              child.secondName) {
              selections.add(child.secondName.toLowerCase());
            }
          }
        }
      }
    }
    return selections;
  }

  onGroupDrodownOpen(flatNode: ProfileFlatNode, $event: any) {
    if ($event) {
      this.getSiblingSelections(flatNode);
    }
  }

  onDegreeDrodownOpen(flatNode: ProfileFlatNode, $event: any) {
    if ($event) {
      this.clearDegreesFilter(flatNode);
    }
  }

  clearFilter(flatNode: ProfileFlatNode) {
    const currentNode = this.flatNodeMap.get(flatNode);
    currentNode.filteredOptions = currentNode.dropdownOptions;
    this.refreshTree(flatNode);
  }

  clearSecondFilter(flatNode: ProfileFlatNode) {
    const currentNode = this.flatNodeMap.get(flatNode);
    currentNode.secondDropdownOptions = currentNode.secondDropdownOptions;
    currentNode.secondDropdownFilteredOptions = currentNode.secondDropdownOptions;
    this.refreshTree(flatNode);
  }

  clearDegreesFilter(flatNode: ProfileFlatNode) {
    const currentNode = this.flatNodeMap.get(flatNode);
    currentNode.filteredDegrees = flatNode.degrees;
    this.refreshTree(flatNode);
  }

  styleDegreeOptions(degree: any) {
    if (degree.isParent) {
      return { 'font-weight': 'bold' };
    } else {
      return { 'margin-left': '20px' };
    }
  }

  styleGroupCustomName(node: ProfileFlatNode) {
    const profileNode = this.flatNodeMap.get(node);
    if (profileNode.validationFailure && profileNode.groupCustomName == '') {
      return {
        border: '2px',
        'border-style': 'dashed',
        'border-color': 'red',
        'border-radius': '4px',
      };
    }
  }

  styleTreeNode(node: ProfileFlatNode) {
    const profileNode = this.flatNodeMap.get(node);
    if (profileNode.validationFailure != undefined && profileNode.validationFailure) {
      return {
        border: '2px',
        'border-style': 'dashed',
        'border-color': 'red',
        'border-radius': '5px',
        cursor: 'move',
      };
      // style="border: 1px solid #ced4da; background: #F9F9FC; border-radius: 5px;"
    } else {
      return {
        border: '1px',
        'border-style': 'solid',
        'border-color': '#ced4da',
        'border-radius': '5px',
        background: '#F9F9FC',
        cursor: 'move',
      };
    }
  }

  saveProfile(profileSaveType: profileSaveType) {
    this.submitted = true;

    if (this.profileForm.status === 'VALID') {
      if (this.dataSource.data.length == 0) {
        this.snackBarService.showError('Profile is empty. Please build a profile before saving.');
        return;
      }

      if (this.selectedCountry.length === 0) {
        this.snackBarService.showError('Please select at least one country.');
        return;
      }

      // check if the profile name already exists
      const extProfileName = this.profileForm.value.externalProfileName;

      if (!this.editMode) {
        const existingProfileNames = this.allProfiles.map((profile) => profile.profileName);
        const indexAt = existingProfileNames.findIndex(
          (profile) => profile.toLowerCase() == extProfileName.toLowerCase(),
        );

        if (indexAt != -1) {
          this.snackBarService.showError(
            "Pofile '" + extProfileName + "' already exists. Please try a different name.",
          );
          return;
        }
      }

      this.validateProfile();

      if (this.profileNoChanges && profileSaveType === 'open') {
        this.snackBarService.showWarning('No changes to save!');
        return; // do not attempt to save the profile
      } else if (this.profileValidationFailure) {
        this.snackBarService.showError(this.profileValidationErrors[0]);
        return; // do not save the profile if there is a validation failures observed...
      }

      const profileToSave = this.convertToProfileForBackend();
      let intProfileName = extProfileName;

      if (!this.profileForm.value.sameAsInternalName) {
        intProfileName = this.profileForm.value.internalProfileName;
      }

      let isActive = this.profileForm.value.isActive;
      isActive = isActive === null ? false : isActive;

      let linkToBenchmark = this.profileForm.value.linkToBenchmark;
      linkToBenchmark = linkToBenchmark === null ? false : linkToBenchmark;

      let linkToMultisite = this.profileForm.value.linkToMultiSite;
      linkToMultisite = linkToMultisite === null ? false : linkToMultisite;

      let linkToGeoskill = this.profileForm.value.linkToGeoskill;
      linkToGeoskill = linkToGeoskill === null ? false : linkToGeoskill;

      let countryCodes = this.profileForm.value.linkToCountry;

      const stringifiedProfile = JSON.stringify(profileToSave);

      this.spinnerService.show(' Saving profile...');

      this.clientIds = this.profileForm.value.client.map((m) => m.id);
      this.profileService
        .saveProfile(
          this.profileId,
          stringifiedProfile,
          extProfileName,
          intProfileName,
          this.isFavorite,
          this.selectedCountry,
          isActive,
          linkToBenchmark,
          linkToMultisite,
          linkToGeoskill,
          this.clientIds,
        )
        .pipe(
          tap((response) => {
            console.log('profile is successfully created...');
            if (profileSaveType === 'close') {
              // if needed take the user back to profile landing page...
              this.profileId = this.profileId == null ? response : this.profileId;
            } else {
              // if user saved and stayed on the page
              this.profileForm.markAsPristine();
              if (response != null) {
                this.profileDetails = response;
              }
              this.profileLoadedInEditMode = JSON.parse(JSON.stringify(this.dataSource.data)); // deep copy

              // change to edit mode
              this.editMode = true;
              this.pageTitle = 'Edit Profile';
              this.profileId = response;
            }
          }),
          catchError((error) => {
            console.error('Drive-Time: Profilewizard -> saveProfile -> error', error);
            this.spinnerService.hide();
            this.snackBarService.showError('Profile could not be saved. Please reach out to support team.');
            return of(null);
          }),
        )
        .subscribe(
          (response) => {
            this.spinnerService.hide();
            this.snackBarService.showInformation("Profile '" + extProfileName + "' has been saved successfully! ");
            if (profileSaveType === 'close') {
              // if needed take the user back to profile landing page...
              this.router.navigate(['/profile/manageprofiles']);
            }
          },
          (error) => {
            console.error('Drive-Time: Profilewizard -> saveProfileClients -> error', error);
            this.spinnerService.hide();
            this.snackBarService.showError('Profile Clients could not be saved. Please reach out to support team.');
          },
        );
    } else {
      // to be implemented
      this.snackBarService.showError('External profile name and Client name are mandatory!');
    }
  }
  onInternalNameCheckboxChange(event: any) {
    if (event.checked) {
      this.isInternalNameReadOnly = true;
      this.profileForm.get('internalProfileName').setValue(this.profileForm.value.externalProfileName);
    } else {
      this.isInternalNameReadOnly = false;
    }
  }

  convertToProfileForBackend() {
    let profile = {};

    const profileFirstLevelNodes = [];

    this.dataSource.data.forEach((element) => {
      const node = this.convertForBackend(element, null);
      profileFirstLevelNodes.push(node);
    });

    profile = {
      [this.profileForm.value.externalProfileName]: profileFirstLevelNodes,
    };

    return profile;
  }

  convertForBackend(obj: ProfileNode, parentNode: ProfileNode) {
    let node = {};

    if (obj.children === undefined || obj.children.length === 0) {
      if (parentNode != null && parentNode.isSupplyGroup != undefined && parentNode.isSupplyGroup) {
        const nestedNode = this.nestedNodeMap.get(parentNode);
        const parentsParentNode = this.getParentNode(nestedNode);
        const flatNode = this.flatNodeMap.get(parentsParentNode);
        if (flatNode.id == 39) {
          node = { [obj.name + ' - Density']: obj.weight };
        } else if (flatNode.id == 51) {
          node = { [obj.name + ' - Count']: obj.weight };
        }
      } else if (obj.isDegreeCompletionGroup != undefined && obj.isDegreeCompletionGroup) {
        if (parentNode.id == 1146) {
          // works for Degree Completions - Count ppl age 18-64
          node = {
            [obj.name + ' - ' + obj.secondName + ' - Count']: obj.weight,
          };
        } else {
          // works for Degree Completions per 10,000 ppl age 18-64
          node = { [obj.name + ' - ' + obj.secondName]: obj.weight };
        }
      } else if (parentNode.isCompetitionResearchGroup != undefined && parentNode.isCompetitionResearchGroup) {
        node = { [parentNode.name + ' - ' + obj.name]: obj.weight };
      } else if (obj.isSkillsGroup != undefined && obj.isSkillsGroup && obj.indicatorType == 'LinkedIn') {
        node = { [obj.name + ' - ' + obj.secondName]: obj.weight }; // for linked in data point append the skill name to variable name
      } else if (parentNode.id == 1165) {
        node = { [obj.name + ' - ' + obj.secondName + ' - Count']: obj.weight };
      } else if (parentNode.id == 1166) {
        node = {
          [obj.name + ' - ' + obj.secondName + ' - Density']: obj.weight,
        };
      } else {
        node = { [obj.name]: obj.weight };
      }
    } else {
      if (obj.isCostGroup || obj.isSupplyGroup) {
        node['Node'] = { [obj.groupCustomName]: obj.weight };
      } else {
        node['Node'] = { [obj.name]: obj.weight };
      }
      node['childNodes'] = [];

      obj.children.forEach((element) => {
        const tempNode = this.convertForBackend(element, obj);
        node['childNodes'].push(tempNode);
      });
    }

    return node;
  }

  showConfirmation(currentNode: ProfileNode, indicator: profileIndicator) {
    this.matDialogSerice
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Are you sure you want to proceeed?',
          description:
            'Changing this indicator will remove all child indicators below it. Are you sure you want to change it?',
          confirmBtnText: 'Ok',
        } as ConfirmDialogConfig,
      })
      .afterClosed()
      .subscribe((result) => {
        const flatNode = this.nestedNodeMap.get(currentNode);
        if (result) {
          this._database.deleteAllChildren(currentNode); // delete all children nodes
          currentNode.name = indicator.indicatorName;
          currentNode.id = indicator.id;
          this.refreshTree(flatNode);
          // this.expandFlatNode(flatNode);
        } else {
          currentNode.name = currentNode.name;
          currentNode.id = currentNode.id;

          flatNode.name = currentNode.name;
          flatNode.id = currentNode.id;
          this.refreshTree(flatNode);
        }
      });
  }

  showSnackBar() {
    this.snackBarService.show('Profile has been saved successfully! ', 'error');
  }

  setEditProfileTree(profileJson: any) {
    this.profileService.getProfileMetaData(this.selectedCountry).subscribe((resp) => {
      this.profileMetaData = resp;
      const profileTree: ProfileNode[] = [];
      profileJson.forEach((element: any, index) => {
        const temp = this.convert(element, null, 1, 100, index);
        profileTree.push(temp);
      });
      this._database.initializeProfile(profileTree);
      this.treeControl.expandAll();
    });
  }

  convert(obj: any, parentNode: ProfileNode, level: number, effectiveWigtht: number, index) {
    const profileNode = new ProfileNode();

    // extract the node name first
    if (obj.childNodes === undefined) {
      // these are leaf nodes
      const leafNodeName = Object.keys(obj)[0];
      profileNode.name = leafNodeName;
    } else {
      const nodeObject = obj['Node'];
      const nodeName = Object.keys(nodeObject)[0];
      profileNode.name = nodeName;
    }

    // check for special scenarios

    if (level === 1) {
      let firstLevelDataPoints = this.getDataPointsForLevel(null, this.countryCode);

      firstLevelDataPoints = this.sortDropdownList(firstLevelDataPoints);

      profileNode.dropdownOptions = firstLevelDataPoints;
      profileNode.filteredOptions = firstLevelDataPoints;
      profileNode.isLeafNode = false;
      const selectedNode = this.getprofileIndicatorByDatapointName(firstLevelDataPoints, profileNode.name);
      if (selectedNode != undefined) {
        profileNode.id = selectedNode.id;
      }
    } else if (parentNode.id == 39 || parentNode.id == 51) {
      let availableDataPoints = this.getSupplyGroups(this.countryCode);

      availableDataPoints = this.sortDropdownList(availableDataPoints);

      profileNode.isSupplyGroup = true;
      profileNode.groupCustomName = profileNode.name;
      profileNode.name = '';
      profileNode.dropdownOptions = availableDataPoints;
      profileNode.filteredOptions = availableDataPoints;
    } else if (parentNode.id == 99 || parentNode.id == 1146) {
      profileNode.isDegreeCompletionGroup = true;

      const degreeItems = this.getDegrees();
      profileNode.degrees = degreeItems;
      profileNode.filteredDegrees = degreeItems;

      profileNode.secondDropdownOptions = this.getDegreeLevels(this.countryCode);

      profileNode.weight = obj[profileNode.name];
      profileNode.effectiveWeight = (profileNode.weight * effectiveWigtht) / 100;

      const degreeName = profileNode.name.split('-')[0].trim();
      const degreeLeval = profileNode.name.split('-')[1].trim();

      profileNode.name = degreeName;
      profileNode.secondName = degreeLeval;

      const selectedNode = this.getdegreeByDatapointName(degreeItems, profileNode.name);
      if (selectedNode != undefined) {
        profileNode.id = selectedNode.id;
      }
    } else if (parentNode.id == 50 || parentNode.id == 67 || parentNode.id == 68 || parentNode.id == 69) {
      let availableDataPoints = this.getCostGroups(this.countryCode);

      availableDataPoints = this.sortDropdownList(availableDataPoints);

      profileNode.isCostGroup = true; // reusing whats created for supply group for cost group.
      profileNode.groupCustomName = profileNode.name;
      profileNode.name = '';
      profileNode.dropdownOptions = availableDataPoints;
      profileNode.filteredOptions = availableDataPoints;
    } else if (parentNode.id == 757) {
      let availableDataPoints = this.getCompetitionReasechItems(this.countryCode);

      availableDataPoints = this.sortDropdownList(availableDataPoints);

      profileNode.dropdownOptions = availableDataPoints;
      profileNode.filteredOptions = availableDataPoints;

      profileNode.isCompetitionResearchGroup = true;

      const selectedNode = this.getprofileIndicatorByDatapointName(availableDataPoints, profileNode.name);
      if (selectedNode != undefined) {
        profileNode.id = selectedNode.id;
      }
    } else if (parentNode.isCompetitionResearchGroup != undefined && parentNode.isCompetitionResearchGroup) {
      const availableDataPoints = this.getCompetitionReasechDropDownItems(this.countryCode);

      profileNode.filteredOptions = availableDataPoints;
      profileNode.dropdownOptions = availableDataPoints;
    } else if (parentNode.id == 1164) {
      profileNode.isLeafNode = true;
      const availableDataPoints = this.getOccupationGroupItems(parentNode.id, this.countryCode);
      profileNode.filteredOptions = availableDataPoints;
      profileNode.dropdownOptions = availableDataPoints;
    } else if (parentNode.id == 1165) {
      this.parentNodeId = parentNode.id;
      profileNode.isOccupationGroup = true;
      profileNode.isLeafNode = true;

      const availableDataPoints = this.getOccupationGroupItems(parentNode.id, this.countryCode);
      profileNode.filteredOptions = availableDataPoints;
      profileNode.dropdownOptions = availableDataPoints;

      const secondDropdownListItems: any = this.getOccupationDiversityGroupItems(parentNode.id, this.countryCode);
      profileNode.secondDropdownFilteredOptions = secondDropdownListItems;
      profileNode.secondDropdownOptions = secondDropdownListItems;

      profileNode.weight = obj[profileNode.name];
      profileNode.effectiveWeight = (profileNode.weight * effectiveWigtht) / 100;

      profileNode.name = profileNode.name.includes(' - Density')
        ? profileNode.name.replace(' - Density', '')
        : profileNode.name;
      profileNode.name = profileNode.name.includes(' - Count')
        ? profileNode.name.replace(' - Count', '')
        : profileNode.name;

      // let name1 = profileNode.name.split(' - ')[0].trim();
      // let name2 = profileNode.name.split(' - ')[1].trim();
      const character = ' - ';
      const index = profileNode.name.lastIndexOf(character);
      const name1 = profileNode.name.substring(0, index).trim();
      const name2 = profileNode.name.substring(index + 2, profileNode.name.length).trim();

      profileNode.name = name1;
      profileNode.secondName = name2;

      const currentNode = this.getprofileIndicatorByDatapointName(availableDataPoints, name1);
      if (currentNode != undefined) {
        profileNode.id = currentNode.id;
      }
    } else if (parentNode.id == 1166) {
      this.parentNodeId = parentNode.id;
      profileNode.isOccupationGroup = true;
      profileNode.isLeafNode = true;

      const availableDataPoints = this.getOccupationGroupItems(parentNode.id, this.countryCode);
      profileNode.filteredOptions = availableDataPoints;
      profileNode.dropdownOptions = availableDataPoints;

      const secondDropdownListItems: any = this.getOccupationDiversityGroupItems(parentNode.id, this.countryCode);
      profileNode.secondDropdownFilteredOptions = secondDropdownListItems;
      profileNode.secondDropdownOptions = secondDropdownListItems;

      profileNode.weight = obj[profileNode.name];
      profileNode.effectiveWeight = (profileNode.weight * effectiveWigtht) / 100;

      profileNode.name = profileNode.name.includes(' - Density')
        ? profileNode.name.replace(' - Density', '')
        : profileNode.name;
      profileNode.name = profileNode.name.includes(' - Count')
        ? profileNode.name.replace(' - Count', '')
        : profileNode.name;

      // let name1 = profileNode.name.split(' - ')[0].trim();
      // let name2 = profileNode.name.split(' - ')[1].trim();
      const character = ' - ';
      const index = profileNode.name.lastIndexOf(character);
      const name1 = profileNode.name.substring(0, index).trim();
      const name2 = profileNode.name.substring(index + 2, profileNode.name.length).trim();

      profileNode.name = name1;
      profileNode.secondName = name2;

      const currentNode = this.getprofileIndicatorByDatapointName(availableDataPoints, name1);
      if (currentNode != undefined) {
        profileNode.id = currentNode.id;
      }
    } else if (parentNode.isSupplyGroup) {
      let availableDataPoints = this.profileMetaData.indicators.occupations.filter(
        (indicator: { countryId: number }) => indicator.countryId === this.countryCode,
      );

      availableDataPoints = this.sortDropdownList(availableDataPoints);

      profileNode.dropdownOptions = availableDataPoints;
      profileNode.filteredOptions = availableDataPoints;

      let nodeName = profileNode.name;

      nodeName = nodeName.includes(' - Density') ? nodeName.replace(' - Density', '') : nodeName;
      nodeName = nodeName.includes(' - Count') ? nodeName.replace(' - Count', '') : nodeName;

      const selectedNode = this.getprofileIndicatorByDatapointName(availableDataPoints, nodeName);
      if (selectedNode != undefined) {
        profileNode.id = selectedNode.id;
      }
    } else if (parentNode.isCostGroup) {
      let availableDataPoints = this.profileMetaData.indicators.costOccupations;

      availableDataPoints = this.sortDropdownList(availableDataPoints);
      profileNode.dropdownOptions = availableDataPoints;
      profileNode.filteredOptions = availableDataPoints;

      const selectedNode = this.getprofileIndicatorByDatapointName(availableDataPoints, profileNode.name);
      if (selectedNode != undefined) {
        profileNode.id = selectedNode.id;
      }
    } else if (
      parentNode.id == 1147 ||
      parentNode.id == 1151 ||
      parentNode.id == 1157 ||
      parentNode.id === 1180 ||
      parentNode.id === 1186 ||
      parentNode.id === 1181 ||
      parentNode.id === 1187) {
      profileNode.isSkillsGroup = true;

      profileNode.weight = obj[profileNode.name];
      profileNode.effectiveWeight = (profileNode.weight * effectiveWigtht) / 100;

      let availableDataPoints = this.getDataPointsForLevel(parentNode.id, this.countryCode);

      availableDataPoints = this.sortDropdownList(availableDataPoints);
      profileNode.dropdownOptions = availableDataPoints;
      profileNode.filteredOptions = availableDataPoints;

      // add logic to populate linked in skills in second drop down

      if (this.isLinkedInDataPoint(profileNode.name)) {
        profileNode.indicatorType = 'LinkedIn';

        const tempName = profileNode.name;
        const splitArray = tempName.split('-');

        if (splitArray.length == 3) {
          profileNode.name = splitArray[0].trim() + ' - ' + splitArray[1].trim();
          profileNode.secondName = tempName.split('-')[2].trim();
        } else {
          profileNode.name = splitArray[0].trim();
          profileNode.secondName = splitArray[1].trim();
        }

        const currentNode = this.getprofileIndicatorByDatapointName(availableDataPoints, profileNode.name);

        let secondDropdownList;
        if (currentNode != undefined && currentNode.id == 1162) {
          secondDropdownList = this.getLinkedInFunctions(this.countryCode);
        } else if (
          currentNode !== null &&
          (currentNode.id === 1176 ||
            currentNode.id === 1177 ||
            currentNode.id === 1175 ||
            currentNode.id === 1170 ||
            currentNode.id === 1171 ||
            currentNode.id === 1172 ||
            currentNode.id === 1180 ||
            currentNode.id === 1181 ||
            currentNode.id === 1182 ||
            currentNode.id === 1183 ||
            currentNode.id === 1184 ||
            currentNode.id === 1185 ||
            currentNode.id === 1186 ||
            currentNode.id === 1187 ||
            currentNode.id === 1188 ||
            currentNode.id === 1189 ||
            currentNode.id === 1190 ||
            currentNode.id === 1191
          )
        ) {
          profileNode.isSkillsGroup = true;
          profileNode.isLeafNode = true;
          secondDropdownList = this.getLinkedInJobFunctions(this.countryCode);
        } else {
          secondDropdownList = this.getLinkedInSkills(this.countryCode);
        }
        profileNode.secondDropdownOptions = secondDropdownList;
        profileNode.secondDropdownFilteredOptions = secondDropdownList;
      }

      const selectedNode = this.getprofileIndicatorByDatapointName(availableDataPoints, profileNode.name);
      if (selectedNode != undefined) {
        profileNode.id = selectedNode.id;
      }
    } else {
      let availableDataPoints = this.getDataPointsForLevel(parentNode.id, this.countryCode, parentNode.name);

      availableDataPoints = this.sortDropdownList(availableDataPoints);

      profileNode.isSupplyGroup = false;
      profileNode.groupCustomName = '';
      profileNode.dropdownOptions = availableDataPoints;
      profileNode.filteredOptions = availableDataPoints;

      const selectedNode = this.getprofileIndicatorByDatapointName(availableDataPoints, profileNode.name);
      if (selectedNode != undefined) {
        profileNode.id = selectedNode.id;
      }

      //Set Add button status based on whether a data point is a category or a leaf node
      const childDataPoints = this.getDataPointsForLevel(profileNode.id, this.countryCode);
      if (this.isOneOfSpecialGroups(profileNode) || (childDataPoints != undefined && childDataPoints.length > 0)) {
        profileNode.isLeafNode = false;
      } else {
        profileNode.isLeafNode = true;
      }
    }

    // generate unique node ids to support drap drop
    if (level === 1) {
      // if parent node
      profileNode.nodeId = '0/' + index;
    } else {
      profileNode.nodeId = parentNode.nodeId + '/' + index;
    }

    // push the nodeId to expanstion model
    this.expansionModel.select(profileNode.nodeId);

    if (obj.childNodes === undefined) {
      // these are leaf nodes
      if (parentNode.id === 1165 || parentNode.id === 1166) {
        // since weight is already set do nothing
      } else if (parentNode != null && parentNode.isSupplyGroup) {
        // check for supply group children and remove density/count from their names...

        profileNode.weight = obj[profileNode.name];
        profileNode.effectiveWeight = (profileNode.weight * effectiveWigtht) / 100;

        let nodeName = profileNode.name;
        nodeName = nodeName.includes(' - Density') ? nodeName.replace(' - Density', '') : nodeName;
        nodeName = nodeName.includes(' - Count') ? nodeName.replace(' - Count', '') : nodeName;

        profileNode.name = nodeName; // overwrite the nodeName so it appears as the selected value on UI.
      } else if (profileNode.isDegreeCompletionGroup || profileNode.isSkillsGroup) {
        // do nothing. weight & eff weights are aleady extracted...
      } else if (parentNode.isCompetitionResearchGroup) {
        profileNode.weight = obj[profileNode.name];
        profileNode.effectiveWeight = (profileNode.weight * effectiveWigtht) / 100;

        let nodeName = profileNode.name;
        const toBeReplace = parentNode.name + ' - ';
        nodeName = nodeName.includes(toBeReplace) ? nodeName.replace(toBeReplace, '') : nodeName;

        profileNode.name = nodeName;
      } else {
        profileNode.weight = obj[profileNode.name];
        profileNode.effectiveWeight = (profileNode.weight * effectiveWigtht) / 100;
      }
    } else {
      const nodeObject = obj['Node'];
      let nodeName = profileNode.name;
      if (profileNode.isSupplyGroup || profileNode.isCostGroup) {
        nodeName = profileNode.groupCustomName;
      }
      profileNode.weight = nodeObject[nodeName];
      profileNode.effectiveWeight = (profileNode.weight * effectiveWigtht) / 100;
      const children = obj['childNodes'];
      profileNode.children = [];

      children.forEach((element: any, index) => {
        const tempNode = this.convert(element, profileNode, level + 1, profileNode.effectiveWeight, index);
        profileNode.children.push(tempNode);
      });
    }
    return profileNode;
  }

  getprofileIndicatorByDatapointName(profileIndicators: profileIndicator[], dataPointName: string) {
    const indicators = profileIndicators.filter(
      (indicator) => indicator.indicatorName.toLowerCase() === dataPointName.toLowerCase(),
    );
    return indicators.find((indicator) => indicator.countryId === 73) || indicators[0] || null;
  }

  getdegreeByDatapointName(degrees: any[], dataPointName: string) {
    return degrees.find((degree) => degree.name.toLowerCase() === dataPointName.toLowerCase());
  }

  sortDropdownList(profileIndicators: profileIndicator[]) {
    return profileIndicators.sort((a: { indicatorName: string }, b: { indicatorName: any }) =>
      a.indicatorName.localeCompare(b.indicatorName),
    );
  }

  validateProfile() {
    this.profileValidationErrors = [];

    // check if any changes are made to profile in edit mode
    if (this.editMode) {
      this.profileNoChanges = false;
      if (
        JSON.stringify(this.dataSource.data) === JSON.stringify(this.profileLoadedInEditMode) &&
        this.profileForm.pristine &&
        this.isFavorite == this.profileDetails.defaultProfile
      ) {
        this.profileNoChanges = true;
        return;
      }
    } else {
      // new profile
      // make a check on the newly created profile...
    }

    // validate the profile...
    this.profileValidationFailure = false;

    this.dataSource.data.forEach((node) => {
      this.checkForValidationFailures(node);
    });

    // validate weather first level data points add up to 100%
    let weight = 0;
    this.dataSource.data.forEach((node) => {
      weight = Number.parseFloat(weight.toString()) + Number.parseFloat(node.weight.toString());
    });

    if (weight < Number.parseFloat('99.5') || weight > Number.parseFloat('100.5')) {
      this.profileValidationErrors.push(
        'Parent indicators do not add up to 100%. Please check your weighting distribution',
      );
      this.profileValidationFailure = true;
    }
  }

  checkForValidationFailures(node: ProfileNode) {
    node.validationFailure = false; // first reset the validation failure flag...
    if (node.children == undefined || node.children.length == 0) {
      if (node.isDegreeCompletionGroup != undefined && node.isDegreeCompletionGroup) {
        if (node.name == '' || node.secondName == '') {
          this.profileValidationErrors.push('Please add both degree name and level to degree completion data points.');
          node.validationFailure = true;
          this.profileValidationFailure = true;
        }
      } else if (node.isSkillsGroup && node.indicatorType == 'LinkedIn') {
        // only for linkedIn type data points
        if (node.name != '' && node.secondName == '') {
          this.profileValidationErrors.push('Please Select a skill from the dropdown.');
          node.validationFailure = true;
          this.profileValidationFailure = true;
        }
      }
      // do this for rest of all leaf data points...
      if (node.name == '') {
        const flatNode = this.nestedNodeMap.get(node);
        const parentFlatNode = this.getParentNode(flatNode);
        this.profileValidationErrors.push(
          'A data point is added but name is not selected under ' + parentFlatNode.name + '.',
        );
        node.validationFailure = true;
        this.profileValidationFailure = true;
      } else if (node.weight === '') {
        // validate wheather data point weight is set
        this.profileValidationErrors.push('Set weight for data point ' + node.name + '.');
        node.validationFailure = true;
        this.profileValidationFailure = true;
      }

      // check if the leaf level data point is a data category...
      const flatNodes = this.nestedNodeMap.get(node);
      if (node.isLeafNode != undefined && node.isLeafNode == false && flatNodes.level != 3) {
        this.profileValidationErrors.push('Please add data points under category ' + node.name + '.');
        node.validationFailure = true;
        this.profileValidationFailure = true;
      }
    } else {
      let weight = 0;
      node.children.forEach((node) => {
        weight = Number.parseFloat(weight.toString()) + Number.parseFloat(node.weight.toString());
      });
      let dataPointName = node.name;

      // for supply group check if the custom group name is entered
      if (
        (node.isSupplyGroup != undefined && node.isSupplyGroup) ||
        (node.isCostGroup != undefined && node.isCostGroup)
      ) {
        if (node.groupCustomName == '') {
          const flatNode = this.nestedNodeMap.get(node);
          const parentFlatNode = this.getParentNode(flatNode);
          node.validationFailure = true;
          this.profileValidationFailure = true;
          this.profileValidationErrors.push(
            "A custom name needs to be entered for group under '" + parentFlatNode.name + "'.",
          );
        } else {
          dataPointName = node.groupCustomName;
        }
      }

      // Check if all children add up to 100% of parent only if the parent weight is non 0

      if (
        node.children.length > 0 &&
        node.weight > Number.parseFloat('0.0') &&
        (weight < Number.parseFloat('99.5') || weight > Number.parseFloat('100.5'))
      ) {
        this.profileValidationErrors.push(
          'Child indicators do not add up to 100%. Please check your weighting distribution',
        );
        node.validationFailure = true;
        this.profileValidationFailure = true;
      }

      // // check if parents weight is 0. A parent that has children data points can not have it's weight as 0.
      // if (node.weight == 0) {
      //   this.profileValidationErrors.push(dataPointName + " can not have 0 weight.")
      //   node.validationFailure = true;
      //   this.profileValidationFailure = true;
      // }

      // Check whether weight was set for the data point
      if (node.weight == '') {
        this.profileValidationErrors.push('Set weight for data point ' + node.name + '.');
        node.validationFailure = true;
        this.profileValidationFailure = true;
      }

      // call the function recursively to validate each child
      node.children.forEach((childNode) => {
        this.checkForValidationFailures(childNode);
      });
    }
  }

  visibleNodes(): ProfileNode[] {
    const result = [];

    function addExpandedChildren(node: ProfileNode, expanded: string[]) {
      result.push(node);
      if (node.children != undefined && node.children.length > 0 && expanded.includes(node.nodeId)) {
        node.children.map((child) => addExpandedChildren(child, expanded));
      }
    }
    this.dataSource.data.forEach((node) => {
      addExpandedChildren(node, this.expansionModel.selected);
    });
    return result;
  }

  /**
   * Handle the drop - here we rearrange the data based on the drop event,
   * then rebuild the tree.
   * */
  drop(event: CdkDragDrop<string[]>) {
    // console.log('origin/destination', event.previousIndex, event.currentIndex);

    // ignore drops outside of the tree
    if (!event.isPointerOverContainer) return;

    // construct a list of visible nodes, this will match the DOM.
    // the cdkDragDrop event.currentIndex jives with visible nodes.
    // it calls rememberExpandedTreeNodes to persist expand state
    const visibleNodes = this.visibleNodes();

    // deep clone the data source so we can mutate it
    const changedData = JSON.parse(JSON.stringify(this.dataSource.data));

    // recursive find function to find siblings of node
    function findNodeSiblings(arr: Array<ProfileNode>, id): Array<any> {
      let result, subResult;
      arr.forEach((item, i) => {
        if (item.nodeId === id) {
          result = arr;
        } else if (item.children) {
          subResult = findNodeSiblings(item.children, id);
          if (subResult) result = subResult;
        }
      });
      return result;
    }

    // determine where to insert the node
    const nodeAtDest = visibleNodes[event.currentIndex];
    const newSiblings = findNodeSiblings(changedData, nodeAtDest.nodeId);
    if (!newSiblings) return;
    const insertIndex = newSiblings.findIndex((s) => s.nodeId === nodeAtDest.nodeId);

    // remove the node from its old place
    const node = event.item.data;
    const siblings = findNodeSiblings(changedData, node.nodeId);
    const siblingIndex = siblings.findIndex((n) => n.nodeId === node.nodeId);
    const nodeToInsert: ProfileNode = siblings.splice(siblingIndex, 1)[0];
    if (nodeAtDest.nodeId === nodeToInsert.nodeId) return;

    // ensure validity of drop - must be same level
    const nodeAtDestFlatNode = this.treeControl.dataNodes.find((n) => nodeAtDest.nodeId === n.nodeId);

    // check parent levels

    const destParentLevel = this.getParentNode(nodeAtDestFlatNode);
    const nodeParentLevel = this.getParentNode(node);

    if (destParentLevel == null && nodeParentLevel == null) {
      // do nothing
    } else if (nodeAtDestFlatNode.level !== node.level || destParentLevel.nodeId !== nodeParentLevel.nodeId) {
      this.snackBarService.showWarning("A data point can't be moved outside it's parent!");
      return;
    }

    // insert node
    newSiblings.splice(insertIndex, 0, nodeToInsert);

    // rebuild tree with mutated data
    this.rebuildTreeForData(changedData);
  }

  /**
   * Experimental - opening tree nodes as you drag over them
   */
  dragStart() {
    this.dragging = true;
  }
  dragEnd() {
    this.dragging = false;
  }
  dragHover(node: ProfileFlatNode) {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
      this.expandTimeout = setTimeout(() => {
        this.treeControl.expand(node);
      }, this.expandDelay);
    }
  }
  dragHoverEnd() {
    if (this.dragging) {
      clearTimeout(this.expandTimeout);
    }
  }

  /**
   * The following methods are for persisting the tree expand state
   * after being rebuilt
   */

  rebuildTreeForData(data: any) {
    this._database.initializeProfile(data);
    // this.dataSource.data = data;
    this.expansionModel.selected.forEach((id) => {
      const node = this.treeControl.dataNodes.find((n) => n.nodeId === id);
      this.treeControl.expand(node);
    });
    // this.treeControl.expandAll();
  }

  restoreExpansionPanel() {
    this.expansionModel.selected.forEach((id) => {
      const node = this.treeControl.dataNodes.find((n) => n.nodeId === id);
      this.treeControl.expand(node);
    });
  }
  setExpansionModel(nodeId: string) {
    if (this.expansionModel.isSelected(nodeId)) {
      this.expansionModel.deselect(nodeId);
    } else {
      this.expansionModel.select(nodeId);
    }
  }

  isOneOfSpecialGroups(profile: ProfileNode) {
    if (
      profile.id == 39 ||
      profile.id == 51 ||
      profile.id == 99 ||
      profile.id == 1146 ||
      profile.id == 50 ||
      profile.id == 67 ||
      profile.id == 68 ||
      profile.id == 69 ||
      profile.id == 757 ||
      profile.isCompetitionResearchGroup == true ||
      profile.id == 1147 ||
      profile.id == 1151 ||
      profile.id == 1157 ||
      profile.id == 1179 ||
      profile.id == 1178
    ) {
      return true;
    } else {
      return false;
    }
  }

  getWeight(weight): any {
    if (weight) {
      return parseFloat(weight);
    } else {
      return weight;
    }
  }

  openAddCompanyDialog() {
    const dialogRef = this.matDialogSerice.open(NewCompanyDialogComponent, {
      width: '500px',
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.getClients(result.id);
    });
  }

  toogleCanadaDisable(): void {
    const isBenchmarkingChecked = this.profileForm.get('linkToBenchmark')?.value;
    const isMultiSiteChecked = this.profileForm.get('linkToMultiSite')?.value;

    this.isCanadaDisable = (isBenchmarkingChecked && isMultiSiteChecked) || isMultiSiteChecked;

    if (this.isCanadaDisable) {
      this.selectedCountry = this.selectedCountry.filter((country) => country !== 'CAN');
      this.clearAllIndicator();
    }
  }
}
